var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron--down--outline_1_",
    "data-name": "chevron--down--outline (1)",
    transform: "translate(16) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29437",
    "data-name": "Path 29437",
    d: "M.808,0,4.571,3.763,8.335,0l.808.808L4.571,5.38,0,.808Z",
    transform: "translate(3.429 6.049)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29438",
    "data-name": "Path 29438",
    d: "M16,8A8,8,0,1,1,8,0,8.009,8.009,0,0,1,16,8ZM1.143,8A6.857,6.857,0,1,0,8,1.143,6.865,6.865,0,0,0,1.143,8Z",
    transform: "translate(0)",
    fill: "#203662"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollLeftIcon);
export default __webpack_public_path__ + "static/media/scrollLeftIcon.119431a7fef8d2b08c154e7f12935636.svg";
export { ForwardRef as ReactComponent };